module.exports = __webpack_public_path__ + "static/media/undraw_building_blocks_n0nc.f80131d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_building_blocks_n0nc.svg
// module id = 47
// module chunks = 1